/*
 * Bloomeroo PDP state-availability strip (informational only).
 * Reads the inlined #bl-availability-map, renders six state badges for the
 * selected variant, and re-renders on variant change. Read-only: never touches
 * the product form, [name="id"], or the Add to Cart button. The cart postcode
 * remains the hard delivery gate.
 */
(function () {
  // Load-once guard — the asset may be re-injected by InstantClick on SPA nav.
  if (window.__blStateAvailLoaded) return;
  window.__blStateAvailLoaded = true;

  // Display order. ACT mirrors NSW (the data has no act key).
  var STATES = [
    { key: 'nsw', label: 'NSW' },
    { key: 'vic', label: 'VIC' },
    { key: 'qld', label: 'QLD' },
    { key: 'sa', label: 'SA' },
    { key: 'wa', label: 'WA' },
    { key: 'act', label: 'ACT', mirror: 'nsw' }
  ];
  // Strip renders only if at least one of these is explicitly false.
  var TRIGGER_KEYS = ['vic', 'nsw', 'qld', 'wa', 'sa'];
  var LABEL = 'Available for dispatch today in:';

  function scopeEl() {
    return document.querySelector('.js-product_section') || document;
  }

  function parseMap(scope) {
    var el = scope.querySelector('#bl-availability-map');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Prefer the form's resolved [name="id"]; fall back to the container's attr.
  function currentVariantId(scope, container) {
    var input = scope.querySelector('[data-product-form] [name="id"]') ||
                scope.querySelector('form [name="id"]') ||
                scope.querySelector('[name="id"]');
    if (input && input.value) return String(input.value);
    return container ? container.getAttribute('data-current-variant') : null;
  }

  function render(scope) {
    var container = scope.querySelector('#bl-availability-strip');
    if (!container) return;

    var map = parseMap(scope);
    var vid = currentVariantId(scope, container);
    if (vid) container.setAttribute('data-current-variant', vid);

    var data = map && vid ? map[vid] : null;
    // No data for this variant, or available everywhere -> render nothing.
    if (!data) { container.innerHTML = ''; return; }
    var anyOut = TRIGGER_KEYS.some(function (k) { return data[k] === false; });
    if (!anyOut) { container.innerHTML = ''; return; }

    var badges = STATES.map(function (s) {
      var srcKey = s.mirror || s.key;
      // Only an explicit false marks a state unavailable.
      var available = data[srcKey] !== false;
      var cls = 'bl-badge ' + (available ? 'bl-badge--available' : 'bl-badge--unavailable');
      return '<span class="' + cls + '">' + s.label + '</span>';
    }).join('');

    container.innerHTML =
      '<div class="bl-availability">' +
        '<span class="bl-availability__label">' + LABEL + '</span>' +
        '<span class="bl-availability__badges">' + badges + '</span>' +
      '</div>';
  }

  // Delegated change listener, bound once. Catches the native select, the
  // OptionSelectors single-option dropdowns, and swatch radios; reads the
  // resolved [name="id"] on the next tick.
  var listenerBound = false;
  function bindChangeOnce() {
    if (listenerBound) return;
    listenerBound = true;
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('[name="id"], .single-option-selector, input[name^="option-"]')) {
        var scope = (t.closest && t.closest('.js-product_section')) || scopeEl();
        setTimeout(function () { render(scope); }, 0);
      }
    }, true);
  }

  function init() {
    render(scopeEl());
    bindChangeOnce();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Turbo / InstantClick SPA navigation: re-render against the new page's map.
  if (window.InstantClick && typeof window.InstantClick.on === 'function') {
    window.InstantClick.on('change', init);
  }
})();
